import { render, staticRenderFns } from "./ChartTeam.vue?vue&type=template&id=2c2457d3&"
import script from "./ChartTeam.vue?vue&type=script&lang=js&"
export * from "./ChartTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports